import React, { useEffect, useMemo } from 'react'
import * as jQuery from 'jquery'
import 'jqueryui'
import DOMPurify from 'dompurify'
import {
  EuiFlyout,
  EuiFlyoutBody
} from '@elastic/eui'

/**
 * Composant Flyout pour afficher le document
 */
const DocumentFlyout = ({ 
  isVisible, 
  onClose, 
  size, 
  bodyHtml,
  onAccordionApply 
}) => {
  const applyAccordion = (active) => {
    const accordionOptions = {
      active: active,
      collapsible: true,
      icons: {},
    }

    setTimeout(() => {
      jQuery('.expand-container').accordion(accordionOptions)
    }, 1500)
  }

  useEffect(() => {
    if (isVisible && bodyHtml) {
      applyAccordion(false)
    }
  }, [isVisible, bodyHtml])

  // Sanitization XSS du HTML Confluence avant injection dans le DOM
  const sanitizedHtml = useMemo(() => {
    if (!bodyHtml) return ''
    const raw = bodyHtml.getElementById('Content')?.innerHTML || ''
    return DOMPurify.sanitize(raw, {
      // On garde les attributs nécessaires aux accordéons Confluence et aux liens
      ADD_ATTR: ['target'],
    })
  }, [bodyHtml])

  if (!isVisible || !bodyHtml) return null

  return (
    <EuiFlyout
      id="flyoutDoc"
      ownFocus
      onClose={onClose}
      size={size}
      aria-labelledby="largeFlyoutTitle"
    >
      <EuiFlyoutBody id="flyoutBody">
        <div dangerouslySetInnerHTML={{ __html: sanitizedHtml }} />
      </EuiFlyoutBody>
    </EuiFlyout>
  )
}

export default DocumentFlyout
